import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/modes");

export const Route = createFileRoute("/modes")({
  head: () => ({
    meta: [
      { title: "Modes — LevelLoad" },
      { name: "description", content: "Modes — LevelLoad transport planning." },
      { property: "og:title", content: "Modes — LevelLoad" },
      { property: "og:description", content: "Modes — LevelLoad transport planning." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
